import React from "react";
import { createBrowserHistory } from "history";
import Footer from "../components/includes/footer/index";
import Header from "../components/includes/header/index";
import { useSelector } from "react-redux";
import Layout from "./layout";
import { allPublicRoute, publisherRoute, bookReaderRoute } from "./allRoute";
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
const history = createBrowserHistory();

function AuthRoute() {
  const { user, loader } = useSelector((state) => state.root);
  return (
    <Router history={history}>
      <Header />

      {user.isLoggedIn ? (
        user?.user?.type === "publisher" ? (
          <Switch>
            {publisherRoute.map((route, inx) => {
              return (
                <Route
                  key={inx}
                  path={route.path}
                  exact={true}
                  render={(props) => {
                    return <Layout {...props} {...route} />;
                  }}
                />
              );
            })}
            <Route
              exact
              render={() => {
                return (
                  user.isLoggedIn && (
                    <Redirect to={`/home/${user?.user?._id}`} />
                  )
                );
              }}
            />
          </Switch>
        ) : (
          <Switch>
            {bookReaderRoute.map((route, inx) => {
              return (
                <Route
                  key={inx}
                  path={route.path}
                  exact={true}
                  render={(props) => {
                    return <Layout {...props} {...route} />;
                  }}
                />
              );
            })}
            <Route
              exact
              render={() => {
                return user.isLoggedIn && <Redirect to="/" />;
              }}
            />
          </Switch>
        )
      ) : (
        <Switch>
          {allPublicRoute.map((route, inx) => {
            return (
              <Route
                key={inx}
                path={route.path}
                exact={true}
                render={(props) => {
                  return <Layout {...props} {...route} />;
                }}
              />
            );
          })}
          <Route
            render={() => {
              return <Redirect to="/" />;
            }}
          />
        </Switch>
      )}

      <Footer />
    </Router>
  );
}

export default AuthRoute;
